import { apiClient, getActivePvzId } from './_shared.js'

/**
 * Получить данные отчета за конкретный рабочий день для ПВЗ
 * @param {string} pvzId
 * @param {string} date - 'YYYY-MM-DD'
 * @returns {Promise<object>}
 */
export async function getDailyReport(pvzId, date) {
  const targetId = pvzId || getActivePvzId()
  if (!targetId || !date) {
    throw new Error('Необходимо указать pvzId и дату отчета')
  }

  return await apiClient(`/reports/daily?pvzId=${encodeURIComponent(targetId)}&date=${encodeURIComponent(date)}`)
}

/**
 * Получить краткую историю ежедневных отчетов за период [from, to] для ПВЗ
 * @param {string} pvzId
 * @param {string} from - 'YYYY-MM-DD'
 * @param {string} to - 'YYYY-MM-DD'
 * @returns {Promise<object>}
 */
export async function getDailyReportsHistory(pvzId, from, to) {
  const targetId = pvzId || getActivePvzId()
  if (!targetId) {
    throw new Error('Необходимо указать pvzId для истории отчетов')
  }

  let query = `/reports/daily-history?pvzId=${encodeURIComponent(targetId)}`
  if (from && to) {
    query += `&from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
  }

  return await apiClient(query)
}
